var map = {
	"./CA/seal.png": 1501,
	"./CA/seal.svg": 1034,
	"./CA/seal_color.png": 1502,
	"./CA/seal_reversed.svg": 1035,
	"./CA/sos-logo.png": 1503,
	"./ID/seal.png": 1504,
	"./ID/seal.svg": 1036,
	"./ID/seal_color.png": 1505,
	"./ID/seal_reversed.svg": 1037,
	"./ID/sos-logo.png": 1506,
	"./MT/mt-sos-logo.png": 1507,
	"./MT/seal.png": 1508,
	"./MT/seal.svg": 1038,
	"./MT/seal_color.png": 1509,
	"./MT/seal_white.png": 1510,
	"./ND/seal.svg": 1039,
	"./SOS/seal.svg": 1040
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 217;



//////////////////
// WEBPACK FOOTER
// ./src/common/img/seals ^\.\/.*$
// module id = 217
// module chunks = 0